export default {
  version: 'master',
  compilation: '300775'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1478
// module chunks = 22